import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_antd@3.15.2@antd/es/progress/index.js
// module id = null
// module chunks = 